import { IconProps } from "@/types/icons";
import clsx from "clsx";

interface ErrorExagonProps extends IconProps {
  className?: string;
}

export const ErrorExagon = ({
  width = 20,
  height = 20,
  className,
  decorative = false,
  ariaLabel = "Error",
}: ErrorExagonProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx(className)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 5.9V14.2L14.1 20H5.9L0 14.2V5.9L5.9 0H14.1L20 5.9ZM9.5 3.7V12.2H10.7V3.7H9.5ZM10.6 16.3H9.4V14.5H10.6V16.3ZM13.7 1L19 6.3V13.8L13.7 19H6.3L1 13.8V6.3L6.3 1H13.7Z"
        fill="#CC334D"
      />
    </svg>
  );
};
